module.exports = __webpack_public_path__ + "static/media/cq_aggiungi.7f24ede5.svg";